import Schedule from'common/components/Schedule/Schedule';export default Schedule;